export enum StudioSizeOptions {
  OneToFour = "1-4",
  FiveToTen = "5-10",
  TenToFifteen = "10-15",
  FifteenToTwentyFive = "15-25",
  TwentyFiveToFourtyFive = "25-45",
  FourtyFiveToAbove = "45 and above",
}

export enum HavePublisherOptions {
  Yes = "Yes",
  No = "No",
  Negotiating = "Negotiating",
  Unsure = "Unsure",
  SelfPublishing = "SelfPublishing",
}

export enum AlreadySignedUpIdXboxOptions {
  Yes = "Yes",
  No = "No",
}

export enum BusinessContactDetailCustomersOptions {
  Yes = "Yes",
  No = "No",
}

export enum KitAlreadyOptions {
  Yes = "Yes",
  No = "No",
  Unknown = "Unknown",
}

export enum LaunchedForConsoleOptions {
  Yes = "Yes",
  No = "No",
}

export enum ContainsNftOrBlockchainOptions {
  Yes = "Yes",
  No = "No",
  Unknown = "Unknown",
}

export enum DevelopmentStageOptions {
  GameConcept = "Game concept",
  Prototype = "Prototype",
  Alpha = "Alpha",
  Beta = "Beta",
  ClosedBeta = "Closed Beta",
  OpenBeta = "Open Beta",
  ReadyToLaunch = "Ready to launch",
  EarlyAccess = "Early Access",
  Launched = "Launched",
}

export enum ReleasedForOtherPlatformsOptions {
  Yes = "Yes",
  No = "No",
}

export enum ReleasedPlatformsOptions {
  Sony = "Sony",
  Steam = "Steam",
  NintendoSwitch = "NintendoSwitch",
  EpicStore = "EpicStore",
  Other = "Other",
}

export enum HasTheGameBeenAnnouncedOptions {
  Yes = "Yes",
  No = "No",
}

export enum TargetedPlatformsOptions {
  SonyPlaystation = "SonyPlaystation",
  Steam = "Steam",
  NintendoSwitch = "NintendoSwitch",
  EpicStore = "EpicStore",
  Other = "Other",
}

export enum GenreOptions {
  Action = "Action",
  Adventure = "Adventure",
  Arcade = "Arcade",
  BattleRoyale = "Battle Royale",
  FirstPersonThirdPersonShooter = "First-Person or Third-Person Shooter",
  MOBA = "MOBA",
  NarrativeStory = "Narrative Story",
  MMORPG = "MMORPG",
  RolePlayingGame = "Role Playing Game",
  Sandbox = "Sandbox",
  Simulation = "Simulation",
  SurvivalHorror = "Survival or Horror",
  Other = "Other",
}

export enum GameEngineOptions {
  Unity = "Unity",
  UnrealEngine = "Unreal Engine",
  Godot = "Godot",
  Other = "Other",
}

export enum BusinessModelOptions {
  Premium = "Premium",
  PremiumPaidDLC = "Premium + Paid DLC",
  PremiumFreeDLC = "Premium + Free DLC",
  FreeToPlay = "Free To Play",
  GamesAsAService = "Games as a Service (Gaas)",
  Other = "Other",
}

export enum OnlineMultiplayerOptions {
  Yes = "Yes",
  No = "No",
}

export enum SensitiveContentOptions {
  Yes = "Yes",
  No = "No",
  Maybe = "Maybe",
  Other = "Other",
}

export enum EnableInputOptions {
  Yes = "Yes",
  No = "No",
  Maybe = "Maybe",
  Other = "Other",
}

export enum FundingSoughtOptions {
  Yes = "Yes",
  No = "No",
  Other = "Other",
}
